import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAvailableOffers } from '@app/core/models/offers.model';

@Component({
  selector: 'layout-available-offer',
  templateUrl: './available-offer.component.html',
  styleUrls: ['./available-offer.component.scss'],
})
export class AvailableOfferComponent implements OnInit {
  @Input() previousInstallmentsSelected: number;
  @Input() hasCard: boolean;
  @Input() availableOffers: IAvailableOffers;
  @Output() closeMaxInstallmentAvailableOfferEvent = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  public onCloseModal(): void {
    this.closeMaxInstallmentAvailableOfferEvent.emit(true);
  }
}
